function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Button, Card, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { EmployeeBioRow } from './';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch } from 'react-redux';
import sortObjectsByProperty from '@rd-web-markets/shared/dist/util/helpers/sort_objects_by_property';
export const EmployeesBioSection = _ref => {
  let {
    accountType,
    claim,
    refreshClaim,
    project
  } = _ref;
  const [claimEmployees, setClaimEmployees] = useState(null);
  const dispatch = useDispatch();
  const claimId = useMemo(() => claim === null || claim === void 0 ? void 0 : claim.id, [claim]);
  const newEmployee = {
    name: '',
    role: '',
    bio: '',
    include_in_technical_report: false,
    claim_id: claim.id,
    claim_project_report_id: project.id
  };
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId, project.id));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    getData();
  }, [dispatch, claimId]);
  const handleDelete = async index => {
    const employee = claimEmployees[index];
    if (employee.id) {
      try {
        await claimEmployeesService.delete(employee, project.id);
        const employees = await claimEmployeesService.all(claim.id, project.id);
        setClaimEmployees(employees);
        refreshClaim();
      } catch (error) {
        dispatch(handleError(error));
      }
    } else {
      const newEmployees = [...claimEmployees];
      newEmployees.splice(index, 1);
      setClaimEmployees(newEmployees);
    }
  };
  const handleAdd = () => {
    setClaimEmployees([...claimEmployees, _objectSpread({}, newEmployee)]);
  };
  const handleEmployeesSort = useCallback(sortBy => {
    const sortedClaimEmployees = sortObjectsByProperty([...claimEmployees], sortBy);
    setClaimEmployees(sortedClaimEmployees);
  }, [claimEmployees]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), claimEmployees.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    onClick: () => handleEmployeesSort('name'),
    role: "button"
  }, "Employee"), /*#__PURE__*/React.createElement("th", {
    onClick: () => handleEmployeesSort('job_role'),
    role: "button"
  }, "Job role, experience and relevant qualifications"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((employee, index) => {
    return /*#__PURE__*/React.createElement(EmployeeBioRow, {
      key: index,
      index: index,
      handleAdd: handleAdd,
      handleDelete: () => handleDelete(index),
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      claim: claim
    });
  })))) : /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5 text-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-muted"
  }, "No data"))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    onClick: () => handleAdd(),
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " Add Row"))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "light",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/general")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/claims/").concat(claim.id, "/financial_details/employees_activity")
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))))));
};